import client from "./client";

export const requestSeats = async (extra) => (await client.post("/seats/request", { extra })).data;
export const resendSeatRequest = async () => (await client.post("/seats/resend")).data;
